import { render, staticRenderFns } from "./cardTrial.vue?vue&type=template&id=2d81e196&scoped=true&"
import script from "./cardTrial.vue?vue&type=script&lang=js&"
export * from "./cardTrial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81e196",
  null
  
)

export default component.exports